module.exports = __webpack_public_path__ + "media/images/app/trust/Safety-a367174ba4b1018ac3b4f816c280bd6a.webp";